module.exports = __webpack_public_path__ + "static/media/Rembuku.f600f21f.PNG";